// State machine mới cho đề tài NCKH sinh viên.
// Đồng bộ với backend: cmcu-crt-be-v2/constant/student_research_status.go.
//
// Mỗi vòng duyệt đều có đủ 3 nhánh (accept/reject/adjust_request — R3).

// --- Registration (gộp đề tài + thành viên — R2) ---
export const STATUS_REGISTRATION_DRAFT          = "registration_draft";
export const STATUS_REGISTRATION_SUBMITTED      = "registration_submitted";
export const STATUS_REGISTRATION_ACCEPTED       = "registration_accepted";
export const STATUS_REGISTRATION_ADJUST_REQUEST = "registration_adjust_request";
export const STATUS_REGISTRATION_REJECTED       = "registration_rejected";

// --- Conducting (Phòng QLKH duyệt thực hiện, gắn mã) ---
export const STATUS_CONDUCTED               = "conducted";
export const STATUS_CONDUCTED_ADJUST_REQUEST = "conducted_adjust_request";
export const STATUS_CONDUCTED_REJECTED      = "conducted_rejected";

// --- Progress reports (refactor 2026-05-14) ---
// BCTĐ tách bảng con, status nằm trên TỪNG row child (iteration 1, 2) — không
// còn ở parent. Status parent đã bỏ NHƯNG vẫn export const để tránh break
// caller cũ (render.js, etc). Các status này không bao giờ được dùng từ BE
// trên parent sau refactor; render.js sẽ skip những entries này.
export const STATUS_PROGRESS_DRAFT          = "progress_draft";
export const STATUS_PROGRESS_SUBMITTED      = "progress_submitted";
export const STATUS_PROGRESS_ACCEPTED       = "progress_accepted";
export const STATUS_PROGRESS_ADJUST_REQUEST = "progress_adjust_request";
export const STATUS_PROGRESS_REJECTED       = "progress_rejected";

// Status cho row child:
export const PROGRESS_REPORT_STATUS_DRAFT          = "draft";
export const PROGRESS_REPORT_STATUS_SUBMITTED      = "submitted";
export const PROGRESS_REPORT_STATUS_ACCEPTED       = "accepted";
export const PROGRESS_REPORT_STATUS_ADJUST_REQUEST = "adjust_request";
export const PROGRESS_REPORT_STATUS_REJECTED       = "rejected";

export const PROGRESS_REPORT_STATUS_LABEL = {
  [PROGRESS_REPORT_STATUS_DRAFT]:          "Nháp",
  [PROGRESS_REPORT_STATUS_SUBMITTED]:      "Chờ duyệt",
  [PROGRESS_REPORT_STATUS_ACCEPTED]:       "Đạt",
  [PROGRESS_REPORT_STATUS_ADJUST_REQUEST]: "Yêu cầu chỉnh sửa",
  [PROGRESS_REPORT_STATUS_REJECTED]:       "Không đạt",
};

// Refactor 2026-08-26: bỏ BCTĐ đợt 2 — đề tài SV chỉ còn 1 báo cáo tiến độ
// duy nhất. Cột `iteration` ở BE giữ lại (constraint + dữ liệu cũ) nên FE
// vẫn phải gửi giá trị này khi nộp/duyệt.
export const PROGRESS_REPORT_ITERATION = 1;

// --- Stop ---
export const STATUS_STOP_REQUESTED = "stop_requested";
export const STATUS_STOP_ACCEPTED  = "stop_accepted";
export const STATUS_STOP_REJECTED  = "stop_rejected";

// --- Acceptance ---
export const STATUS_ACCEPTANCE_READY          = "acceptance_ready";
export const STATUS_ACCEPTANCE_SUBMITTED      = "acceptance_submitted";
export const STATUS_COUNCIL_ASSIGNED          = "council_assigned";
export const STATUS_COUNCIL_SCORED            = "council_scored";
export const STATUS_ACCEPTANCE_ACCEPTED       = "acceptance_accepted";
export const STATUS_ACCEPTANCE_ADJUST_REQUEST = "acceptance_adjust_request";
export const STATUS_ACCEPTANCE_REJECTED       = "acceptance_rejected";

// --- Cấp Trường / Quốc gia / Quốc tế (Phòng QLKH, sau khi Trưởng khoa chấm
// cấp Khoa và đề xuất báo cáo tại HNSV) ---
export const STATUS_SCHOOL_LEVEL_PENDING        = "school_level_pending";
export const STATUS_SCHOOL_LEVEL_DONE           = "school_level_done";
export const STATUS_NATIONAL_LEVEL_PENDING      = "national_level_pending";
export const STATUS_NATIONAL_LEVEL_DONE         = "national_level_done";
export const STATUS_INTERNATIONAL_LEVEL_PENDING = "international_level_pending";
export const STATUS_INTERNATIONAL_LEVEL_DONE    = "international_level_done";

// Toàn bộ status parent theo thứ tự quy trình — dùng để xác định step hiện
// tại. Refactor 2026-05-14: progress_* bỏ khỏi parent (chuyển sang bảng con).
export const STUDENT_RESEARCH_STATUS = [
  STATUS_REGISTRATION_DRAFT,
  STATUS_REGISTRATION_SUBMITTED,
  STATUS_REGISTRATION_ADJUST_REQUEST,
  STATUS_REGISTRATION_REJECTED,
  STATUS_REGISTRATION_ACCEPTED,

  STATUS_CONDUCTED,
  STATUS_CONDUCTED_ADJUST_REQUEST,
  STATUS_CONDUCTED_REJECTED,

  STATUS_STOP_REQUESTED,
  STATUS_STOP_REJECTED,
  STATUS_STOP_ACCEPTED,

  STATUS_ACCEPTANCE_READY,
  STATUS_ACCEPTANCE_SUBMITTED,
  STATUS_COUNCIL_ASSIGNED,
  STATUS_COUNCIL_SCORED,
  STATUS_ACCEPTANCE_ADJUST_REQUEST,
  STATUS_ACCEPTANCE_REJECTED,
  STATUS_ACCEPTANCE_ACCEPTED,

  STATUS_SCHOOL_LEVEL_PENDING,
  STATUS_SCHOOL_LEVEL_DONE,
  STATUS_NATIONAL_LEVEL_PENDING,
  STATUS_NATIONAL_LEVEL_DONE,
  STATUS_INTERNATIONAL_LEVEL_PENDING,
  STATUS_INTERNATIONAL_LEVEL_DONE,
];

// Label hiển thị cho từng status.
export const STUDENT_RESEARCH_STATUS_LABEL = {
  [STATUS_REGISTRATION_DRAFT]:          "Nháp đăng ký",
  [STATUS_REGISTRATION_SUBMITTED]:      "Chờ trưởng khoa duyệt đăng ký",
  [STATUS_REGISTRATION_ACCEPTED]:       "Đăng ký đã duyệt — chờ Phòng QLKH",
  [STATUS_REGISTRATION_ADJUST_REQUEST]: "Yêu cầu chỉnh sửa đăng ký",
  [STATUS_REGISTRATION_REJECTED]:       "Đăng ký bị loại",

  [STATUS_CONDUCTED]:               "Đang thực hiện",
  [STATUS_CONDUCTED_ADJUST_REQUEST]:"Yêu cầu chỉnh sửa (QLKH)",
  [STATUS_CONDUCTED_REJECTED]:      "Bị loại ở bước duyệt thực hiện",

  // Báo cáo tiến độ. Refactor 2026-05-14 từng bỏ label parent (BCTĐ chuyển
  // sang bảng con), nhưng như vậy đề tài đã nộp BCTĐ vẫn hiển thị "Đang thực
  // hiện" — không phân biệt được với đề tài chưa nộp. Khôi phục 2026-09-03:
  // BE đẩy lại trạng thái cha ở cả 3 nhánh duyệt.
  [STATUS_PROGRESS_DRAFT]:          "Nháp báo cáo tiến độ",
  [STATUS_PROGRESS_SUBMITTED]:      "Đã nộp BCTĐ — chờ Khoa duyệt",
  [STATUS_PROGRESS_ACCEPTED]:       "Báo cáo tiến độ đạt",
  [STATUS_PROGRESS_ADJUST_REQUEST]: "Khoa yêu cầu chỉnh sửa BCTĐ",
  [STATUS_PROGRESS_REJECTED]:       "Báo cáo tiến độ không đạt",

  [STATUS_STOP_REQUESTED]: "Xin dừng — chờ duyệt",
  [STATUS_STOP_ACCEPTED]:  "Đã dừng đề tài",
  [STATUS_STOP_REJECTED]:  "Từ chối dừng",

  [STATUS_ACCEPTANCE_READY]:          "Sẵn sàng nộp báo cáo tổng kết",
  [STATUS_ACCEPTANCE_SUBMITTED]:      "Đã nộp báo cáo tổng kết",
  [STATUS_COUNCIL_ASSIGNED]:          "Đã gán hội đồng nghiệm thu",
  [STATUS_COUNCIL_SCORED]:            "Hội đồng đã chấm — chờ kết luận",
  // acceptance_accepted là trạng thái KẾT THÚC: Trưởng khoa đã chấm cấp Khoa
  // với action=accept và eligible=false (không đề xuất báo cáo tại HNSV cấp
  // Trường). Nếu eligible=true thì đề tài đi sang school_level_pending.
  [STATUS_ACCEPTANCE_ACCEPTED]:       "Nghiệm thu đạt — không đề xuất lên cấp Trường",
  [STATUS_ACCEPTANCE_ADJUST_REQUEST]: "Yêu cầu chỉnh sửa sau nghiệm thu",
  [STATUS_ACCEPTANCE_REJECTED]:       "Nghiệm thu không đạt",

  [STATUS_SCHOOL_LEVEL_PENDING]:        "Chờ Phòng QLKH chấm cấp Trường",
  [STATUS_SCHOOL_LEVEL_DONE]:           "Kết thúc — không đề xuất cấp Bộ",
  [STATUS_NATIONAL_LEVEL_PENDING]:      "Chờ Phòng QLKH cập nhật kết quả cấp Quốc gia",
  [STATUS_NATIONAL_LEVEL_DONE]:         "Kết thúc — không đề xuất cấp Quốc tế",
  [STATUS_INTERNATIONAL_LEVEL_PENDING]: "Chờ Phòng QLKH cập nhật kết quả cấp Quốc tế",
  [STATUS_INTERNATIONAL_LEVEL_DONE]:    "Kết thúc — đã có kết quả cấp Quốc tế",
};

// Giải chính (R4) — kết quả nghiệm thu cấp Khoa, mỗi đề tài tối đa 1 giải chính.
export const MAIN_PRIZE_PASS      = "pass";
export const MAIN_PRIZE_FAIL      = "fail";
export const MAIN_PRIZE_FIRST     = "first";
export const MAIN_PRIZE_SECOND    = "second";
export const MAIN_PRIZE_THIRD     = "third";
export const MAIN_PRIZE_ENCOURAGE = "encourage";

export const MAIN_PRIZE_OPTIONS = [
  { value: MAIN_PRIZE_FAIL,      label: "Không nghiệm thu" },
  { value: MAIN_PRIZE_PASS,      label: "Nghiệm thu" },
  { value: MAIN_PRIZE_ENCOURAGE, label: "Khuyến khích" },
  { value: MAIN_PRIZE_THIRD,     label: "Giải ba" },
  { value: MAIN_PRIZE_SECOND,    label: "Giải nhì" },
  { value: MAIN_PRIZE_FIRST,     label: "Giải nhất" },
];

// Kết quả cấp Trường / Quốc gia / Quốc tế (R4b, Phòng QLKH) — khác cấp Khoa:
// không có khái niệm đạt/không đạt (đã qua cấp Khoa rồi), sàn là "Tham gia";
// riêng cấp Quốc gia có thêm "Vào vòng chung kết".
export const CONFERENCE_RESULT_PARTICIPATE = "participate";
export const CONFERENCE_RESULT_FINALIST    = "finalist";
export const CONFERENCE_RESULT_ENCOURAGE   = "encourage";
export const CONFERENCE_RESULT_THIRD       = "third";
export const CONFERENCE_RESULT_SECOND      = "second";
export const CONFERENCE_RESULT_FIRST       = "first";

// Cấp Trường và cấp Quốc tế dùng chung 1 bộ 5 giá trị.
export const SCHOOL_LEVEL_RESULT_OPTIONS = [
  { value: CONFERENCE_RESULT_PARTICIPATE, label: "Tham gia" },
  { value: CONFERENCE_RESULT_ENCOURAGE,   label: "Khuyến khích" },
  { value: CONFERENCE_RESULT_THIRD,       label: "Giải ba" },
  { value: CONFERENCE_RESULT_SECOND,      label: "Giải nhì" },
  { value: CONFERENCE_RESULT_FIRST,       label: "Giải nhất" },
];

// Cấp Quốc gia: thêm "Vào vòng chung kết" sau "Tham gia".
export const NATIONAL_LEVEL_RESULT_OPTIONS = [
  { value: CONFERENCE_RESULT_PARTICIPATE, label: "Tham gia" },
  { value: CONFERENCE_RESULT_FINALIST,    label: "Vào vòng chung kết" },
  { value: CONFERENCE_RESULT_ENCOURAGE,   label: "Khuyến khích" },
  { value: CONFERENCE_RESULT_THIRD,       label: "Giải ba" },
  { value: CONFERENCE_RESULT_SECOND,      label: "Giải nhì" },
  { value: CONFERENCE_RESULT_FIRST,       label: "Giải nhất" },
];

// Loại hội đồng.
export const COUNCIL_TYPE_PROGRESS = "progress";
export const COUNCIL_TYPE_FINAL    = "final";

// Hành động review (R3).
export const REVIEW_ACTION_ACCEPT         = "accept";
export const REVIEW_ACTION_REJECT         = "reject";
export const REVIEW_ACTION_ADJUST_REQUEST = "adjust_request";

// Duration — refactor 2026-05-14: đề tài SV cố định 6 tháng (đơn vị tháng).
// Field tên `durationMonths`. Admin có thể chỉnh đặc biệt (3/9/...) cho case
// hiếm.
export const DEFAULT_DURATION_MONTHS = 6;

// Iteration của BCTĐ — đề tài SV 6 tháng bắt buộc 2 lần BCTĐ cách ~2 tháng.
export const PROGRESS_ITERATIONS = [1, 2];

// (Deprecated, giữ tạm để các caller cũ không bị crash khi import — sẽ xóa
// sau khi sweep xong các container.)
export const DURATION_ONE_YEAR = 1;
export const DURATION_TWO_YEAR = 2;
export const DURATION_OPTIONS = [{ value: DEFAULT_DURATION_MONTHS, label: "6 tháng" }];
